import { DocumentImport } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { FunctionalModal } from 'component/modal/functional-modal';
import { t } from 'util/stdtypes';

export function UnpublishSpaceModal({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) {
    const { colors } = useTheme();
    return (
        <FunctionalModal
            headingLabel={t('question.actions.unpublish_modal_heading', 'Unpublish this space?')}
            onClose={onClose}
            primaryButton={{
                label: t('question.actions.unpublish_confirm_button', 'Unpublish'),
                icon: <DocumentImport color={colors.colorTextWarning} />,
                type: 'delete',
                onPress: onConfirm,
            }}
            secondaryButton={{
                label: t('modal.cancel_button', 'Cancel'),
                onPress: onClose,
            }}
            subheadingLabel={t(
                'question.actions.unpublish_modal_description',
                'Once unpublished, this space will no longer be visible to users on your production site and will stop being indexed for SEO. You can republish the conversation at any time.',
            )}
        />
    );
}
